import { Reducer } from "redux";
import { PayState, PayActionTypes } from "./types";

// 初始化state
export const initPayState: PayState = {
  payList: [],
  pagination: {
    pageSize: 10,
    current: 1,
    total: 0
  },
  loading: {
    showA: false,
    showB: false,
    text: "",
    second: 0
  },
  onePay: {
    batchNo: "",
    totalAmount: 0,
    totalNum: 0,
    filePath: "",
    payDate: "",
    bizLine: 1,    // 业务线：目前只有1，暂时写死
    dataSource: 1, // 发薪来源：企业端：1，暂时写死
    channelId: 20, // 业务渠道标识：企业角色：20
    tempUrl: "",
    tempFields: "",
    isShowNew: false,
    isShowModal: false,
    fileName: "",
    size: 0,
    imageList: []
  },
  statusList: [],
  exportExcel: {
    showRate: false,
    rate: 0
  },
  isShowPic: false
};

// 发放reducer
const payReducer: Reducer<PayState> = (state = initPayState, action) => {
  switch (action.type) {

    // 查询发放列表
    case PayActionTypes.FETCH_QUERY_PAY_LIST_FINISH: {
      const { payList, pagination } = action.payload;
      return {
        ...state,
        payList,
        pagination,
      }
    }

    // loading
    case PayActionTypes.FETCH_LOADING: {
      const { loading } = state;
      const obj = { ...action.payload };
      return {
        ...state,
        loading: {
          ...loading,
          ...obj
        }
      }
    }

    // onePay字段赋值
    case PayActionTypes.FETCH_QUERY_ONEPAY_FINISH: {
      const { onePay } = state;
      const obj = { ...action.payload };
      return {
        ...state,
        onePay: {
          ...onePay,
          ...obj
        }
      }
    }

    // 查询状态下拉列表
    case PayActionTypes.FETCH_STATUS_LIST_FINISH: {
      return {
        ...state,
        statusList: action.payload
      }
    }

    // 根据taskId轮询导出excel
    case PayActionTypes.FETCH_EXPORT_BY_TASKID_FINISH: {
      return {
        ...state,
        exportExcel: action.payload
      }
    }

    // 点击查看图片
    case PayActionTypes.FETCH_SHOW_PIC: {
      return {
        ...state,
        isShowPic: action.payload
      }
    }

    default: {
      return { ...state };
    }
  }
}

export { payReducer }



// WEBPACK FOOTER //
// ./src/store/pay/reducer.ts